import React, { useState, useEffect,Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../assets/css/source.scss';
import { graphql } from "gatsby";

import {SEO} from '../components/primary/SEO/SEO'
import Footer from '../components/primary/Footer/Footer';
import Navbar from '../components/primary/Navbar/Navbar';

import OpenStore from "../components/templates/openStore/OpenStore";
import Breadcrumbs from '../components/local/breadcrumbs/Breadcrumbs';
import ClosedStore from "../components/templates/closedStore/ClosedStore";
import Newsletter from "../components/sections/Newsletter/Newsletter";

import { ApiHooks } from "../services/api";
import { InfoContext} from '../context/Context';
import SkeletonHome from '@skeleton/SkeletonHome';

export default function Moment({data, pageContext: {slug}, pageContext  }) {
  //Hooks
  const { getStoreLoans, getCentralStore} = ApiHooks();
  //States
  const [storeUberall, setStoreUberall] = useState(null); 
  const [storeLocatorUberall, setStoreLocatorUberall] = useState(null);
  const [loansInfo, setLoansInfo] = useState(null); 
  //Variables
  let [ status_store,  zip_code, corporate_id ] = [ data.momentFeed.status, data.momentFeed.zip, data.momentFeed.corporate_id];
  const moment_feed = data.momentFeed.momentfeed_id;
  const id_uberall = data.momentFeed.id_uberall;
  const internal_id = data.momentFeed.internal_id;
  //Data for the axios
  const loans = JSON.stringify({
    state: data.momentFeed.state,
    brand: data.momentFeed.name,
    state_min: data.momentFeed.state_min
  }); 
  const lat = `lat=${data.momentFeed.lat}&lng=${data.momentFeed.long}`; 
  const positions = {
    lat: data.momentFeed.lat,
    lng: data.momentFeed.long
  }
  //First Call for the Store
  useEffect(() => {
    if(status_store === "open"){
      const store_uberall = getCentralStore(internal_id, "store_uberall");
      const store_loca_uberall = getCentralStore(positions, "store_locator_uberall"); 
      
      const store_loans   = getStoreLoans(loans, "loans");
      store_uberall.then((response) => {
        setStoreUberall(response.data.response);
      })
      store_loca_uberall.then((response) => {
        setStoreLocatorUberall(response.data.response);
      })
      store_loans.then((response) => {
        setLoansInfo(response);
      })
    }
    else{
      setStoreUberall("");
      setLoansInfo("");
    }
    return () => {
      setLoansInfo(null);
    };
  }, [status_store])
/* */  
  const verifiedInfo = () => {
    if(storeUberall !== null){
      if(status_store === "open"){
        return(
          <Fragment>
            <Breadcrumbs />
            <InfoContext.Provider value={{pageContext, data, loansInfo, storeUberall, storeLocatorUberall}}>
              <OpenStore/>
            </InfoContext.Provider>
          </Fragment>
        )
      }
      else{
        return(
          <Fragment>
            <ClosedStore data={data} />
          </Fragment>
        )
      }
    }
  }
  return (
    <Fragment>
      <Navbar />
      { 
        (typeof storeUberall === 'object' && storeUberall === null)  
        ? (
            <Fragment>
              <Breadcrumbs />
              <SkeletonHome />
          </Fragment>
        ) 
        : verifiedInfo()
      }
      <Newsletter />
      <Footer />
      {/* data={data.allWpMenu} */}
    </Fragment>
  )
}
export const query = graphql`
query MyQuery ($slug: String)  {
  momentFeed(post_name: {eq:  $slug}) {
    address
    status
    state_min
    state
    post_name
    name
    momentfeed_id
    id_uberall
    internal_id
    businessIdentifier
    identifier
    locality
    corporate_id
    id
    zip
    phone
    html
    lat
  long
  }
  allWpMenu {
    nodes {
      id
      name
      slug
      menuItems {
        nodes {
              id
              description
              databaseId
              uri
              label
              parentDatabaseId
            }
      }
    }
  }
}
` 
export const Head = ({data}) => {
  return(
    <SEO 
      img="https://cacheckcashdev.wpengine.com/wp-content/plugins/cic-moment-feed/img/california.jpg"
      title={`${data.momentFeed.address}, ${data.momentFeed.state} - ${process.env.GATSBY_BRAND}`} 
      description={`Get ${data.momentFeed.name} at ${data.momentFeed.address}. For all your quick cash needs like Cash Advance, Installment Loans, ${data.momentFeed.name}, and more in ${data.momentFeed.locality}, ${data.momentFeed.state}.`}
    /> 
  )
}